var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"svg-icon",class:_vm.className,attrs:{"aria-hidden":"true"},on:{"click":_vm.handleClick}},[_c('use',{attrs:{"xlink:href":`#${_vm.icon}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }